import { Directive, ElementRef, EventEmitter, OnInit, Output } from '@angular/core';
import { NbToastrConfig, NbToastrService } from '@nebular/theme';

@Directive({
  selector: '[ngModel][inputNumber]',
  host: {
    "(input)": 'onInputChange()'
  }
})
export class InputNumberDirective implements OnInit {
  @Output() ngModelChange: EventEmitter<any> = new EventEmitter();

  private _toastConfig: Partial<NbToastrConfig> = {
    duration: 5000,
    destroyByClick: false,
    status: 'warning',
    icon: { icon: 'alert-circle-outline', pack: 'eva' },
    preventDuplicates: true
  };

  constructor(private toastService: NbToastrService,
    private el: ElementRef) {
  }

  ngOnInit() { }

  onInputChange() {
    const min = Number(this.el.nativeElement.min);
    const max = Number(this.el.nativeElement.max);

    if (this.el.nativeElement.value < min) {
      this.el.nativeElement.value = min;
      this.ngModelChange.emit(min);
      this.toastService.warning(`${min} 보다 낮게 설정할 수 없습니다.`, this._toastConfig);
    }

    if (this.el.nativeElement.value > max) {
      this.el.nativeElement.value = max;
      this.ngModelChange.emit(max);
      this.toastService.warning(`${max} 보다 높게 설정할 수 없습니다.`, this._toastConfig);
    }
  }
}
